<template>
  <div class="ed-page">

    <!-- Hero -->
    <div class="ed-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-account-edit-outline</v-icon>
        </v-avatar>
        <div>
          <div class="ed-hero__title">Edición de datos personales</div>
          <div class="ed-hero__sub" v-if="user.pri_apellido">
            {{ user.pri_apellido }} {{ user.seg_apellido }} — CI: {{ input.num_doc }}
            <span v-if="departamento_sel"> {{ departamento_sel.extension }}</span>
          </div>
        </div>
      </div>
      <div class="d-flex align-center" style="gap:8px;">
        <v-chip small color="rgba(255,255,255,0.15)" dark>
          <v-icon left small>mdi-school-outline</v-icon> Académico
        </v-chip>
        <v-btn small dark text @click="$router.back()">
          <v-icon left small>mdi-arrow-left</v-icon> Volver
        </v-btn>
      </div>
    </div>

    <v-progress-linear indeterminate color="indigo" v-if="loading" height="3" />

    <div class="ed-body">

      <!-- Info de solo lectura -->
      <v-card outlined class="ed-info-card mb-4" v-if="user.pri_apellido">
        <v-card-text class="py-2 px-4 d-flex flex-wrap align-center" style="gap:16px;">
          <div class="ed-info-item">
            <span class="ed-info-label">Documento</span>
            <span class="ed-info-val">{{ input.num_doc }}
              <small v-if="departamento_sel" class="grey--text">{{ departamento_sel.extension }}</small>
            </span>
          </div>
          <v-divider vertical class="mx-1" />
          <div class="ed-info-item">
            <span class="ed-info-label">Apellido 1</span>
            <span class="ed-info-val">{{ user.pri_apellido }}</span>
          </div>
          <v-divider vertical class="mx-1" />
          <div class="ed-info-item">
            <span class="ed-info-label">Apellido 2</span>
            <span class="ed-info-val">{{ user.seg_apellido || '—' }}</span>
          </div>
        </v-card-text>
      </v-card>

      <!-- Formulario -->
      <v-card outlined class="ed-form-card">
        <v-card-title class="ed-form-title py-2 px-4">
          <v-icon small color="indigo darken-2" class="mr-1">mdi-form-select</v-icon>
          Datos editables
        </v-card-title>
        <v-card-text class="pt-4 pb-2 px-4">

          <v-row dense>
            <v-col cols="12" sm="4">
              <v-text-field v-model.trim="input.nombres" label="Nombres"
                outlined dense prepend-inner-icon="mdi-account-outline" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-combobox :items="departamentos" v-model="departamento_sel"
                :disabled="onlyread_ci" label="Departamento (extensión CI)"
                outlined dense return-object clearable item-text="nombre"
                prepend-inner-icon="mdi-map-marker-outline" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-combobox :items="paises" v-model="pais_sel" label="Nacionalidad"
                outlined dense return-object item-text="nombre"
                prepend-inner-icon="mdi-flag-outline" />
            </v-col>

            <v-col cols="12" sm="8">
              <v-combobox :items="instituciones" v-model="institucion_sel"
                label="Institución de egreso"
                outlined dense return-object clearable item-text="label"
                prepend-inner-icon="mdi-school-outline" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-combobox :items="grados" v-model="grado_sel" label="Grado académico"
                outlined dense multiple return-object item-text="nombre"
                prepend-inner-icon="mdi-certificate-outline" />
            </v-col>

            <v-col cols="12" sm="4">
              <vue-tel-input v-model="input.telefono1" class="ed-tel-input" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field v-model.trim="input.email" label="Correo electrónico"
                outlined dense prepend-inner-icon="mdi-email-outline" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-select :items="est_civils" v-model="est_civil_sel" label="Estado Civil"
                outlined dense return-object item-text="n"
                prepend-inner-icon="mdi-heart-outline" />
            </v-col>

            <v-col cols="12" sm="4">
              <v-combobox :items="profesiones" v-model="profesiones_sel" label="Profesiones"
                outlined dense multiple chips clearable return-object item-text="nombre"
                prepend-inner-icon="mdi-briefcase-outline" />
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field v-model.trim="input.domicilio" label="Domicilio"
                outlined dense prepend-inner-icon="mdi-home-outline" />
            </v-col>
          </v-row>

        </v-card-text>
        <v-divider />
        <v-card-actions class="px-4 py-3">
          <v-spacer />
          <v-btn color="indigo darken-1" dark depressed :loading="loading" @click="guardar()">
            <v-icon left>mdi-content-save</v-icon> Guardar cambios
          </v-btn>
        </v-card-actions>
      </v-card>

    </div>
  </div>
</template>

<script>
import PersonService from './personService'

export default {
  data() {
    return {
      onlyread_ci: false,
      loading: false,
      user_id: null,
      personService: new PersonService(),
      instituciones: [],
      profesiones: [],
      departamentos: [],
      paises: [],
      profesiones_sel: [],
      grados: [],
      est_civils: [{ id: 'S', n: 'Soltero' }, { id: 'C', n: 'Casado' }, { id: 'V', n: 'Viudo' }, { id: 'D', n: 'Divorciado' }],
      institucion_sel: null,
      departamento_sel: null,
      est_civil_sel: null,
      grado_sel: [],
      pais_sel: null,
      user: {},
      input: { nombres: '' },
    };
  },
  watch: {
    'pais_sel': function() {
      this.onlyread_ci = false;
      if (this.pais_sel && this.pais_sel.id != 1) {
        this.departamento_sel = this.departamentos.find(x => x.id == 10);
        this.onlyread_ci = true;
      }
    },
  },
  methods: {
    async getdata() {
      this.onlyread_ci = false;
      this.loading = true;
      const res = await this.personService.getPersona(this, this.user_id);
      const d = res.data.getPersona;
      this.user = d;
      this.institucion_sel = null;
      this.departamento_sel = null;
      this.est_civil_sel = null;
      this.grado_sel = [];
      this.pais_sel = null;
      this.profesiones_sel = [];
      delete this.input.idinstitucion;
      delete this.input.profesiones;
      this.input.nombres = d.nombres;
      this.input.num_doc = d.num_doc;
      this.input.email = d.email;
      this.input.sexo = d.sexo;
      this.input.tipo = d.tipo;
      this.input.diestro = d.diestro;
      this.input.domicilio = d.domicilio;
      this.input.telefono1 = d.telefono1;
      this.input.est_civil = d.est_civil;
      this.input.pri_apellido = d.pri_apellido;
      this.input.seg_apellido = d.seg_apellido;

      const res2 = await this.personService.getInstituciones(this);
      res2.data.getInstituciones.forEach(x => x.label = `(${x.abreviatura}) ${x.nombre}`);
      this.instituciones = res2.data.getInstituciones;
      const ins = this.user.idinstitucion;
      if (ins) this.institucion_sel = this.instituciones.find(x => x.id == ins);

      const tp = this.input.tipo;
      if (tp != 'E' && tp != 'P') this.input.tipo = 'E';

      const res3 = await this.personService.getProfesiones(this);
      this.profesiones = res3.data.getProfesiones;
      const pfs = this.user.profesiones;
      if (pfs) this.profesiones_sel = this.profesiones.filter(x => pfs.some(a => a.id == x.id));

      const res4 = await this.personService.getDepartamentos(this);
      let dps = res4.data.getDepartamentos.filter(x => x.id <= 10);
      this.departamentos = dps;
      this.departamento_sel = this.departamentos.find(x => x.id == d.iddepartamento);
      this.est_civil_sel = this.est_civils.find(x => x.id == d.est_civil);

      const res5 = await this.personService.getGrados(this);
      this.grados = res5.data.getGrados;
      const gds = this.user.grados;
      if (gds) {
        window.console.log('gds', gds, this.grados);
        this.grado_sel = this.grados.filter(x => gds.some(a => a.nombre == x.nombre));
      }

      const res6 = await this.personService.getPaises(this);
      this.paises = res6.data.getPaises;
      this.pais_sel = this.paises.find(x => x.id == d.idpais);

      this.loading = false;
    },

    tieneCaracteresespeciales(cadena) {
      const regex = /[ÁÉÍÓÚÑ áéíóúñ]/;
      return regex.test(cadena);
    },

    async guardar() {
      const idcargo = this.$store.state.CARGO.id;
      if (idcargo != 8 && idcargo != 1) {
        this.$root.$notify.show('No eres digno :)', { color: 'red' });
        return;
      }
      delete this.input.idinstitucion;
      delete this.input.profesiones;
      delete this.input.idpais;
      delete this.input.iddepartamento;
      delete this.input.grados;
      delete this.input.profesiones;
      this.input.iddepartamento = null;

      if (this.institucion_sel) this.input.idinstitucion = this.institucion_sel.id;
      if (this.profesiones_sel && this.profesiones_sel.length > 0) {
        this.input.profesiones = this.profesiones_sel.map(item => item.id);
      }
      if (this.profesiones_sel.length == 0) {
        this.$root.$notify.show('Seleccione al menos una profesion', { color: 'red' });
        return;
      }
      if (!this.input.domicilio || this.input.domicilio.length < 5) {
        this.$root.$notify.show('El domicilio debe tener mas de 5 caracteres', { color: 'red' });
        return;
      }
      if (!this.est_civil_sel) {
        this.$root.$notify.show('El estado civil debe ser seleccionado', { color: 'red' });
        return;
      }

      const especiales = this.tieneCaracteresespeciales(this.input.email);
      if (especiales) {
        this.$root.$notify.show('el correo no debe contener caracteres mayusculas ni tildes ni la letra ñ', { color: 'red' });
        return;
      }
      if (this.grado_sel && this.grado_sel.length > 1) {
        this.$root.$notify.show('seleccione solamente el grado academico mas alto', { color: 'red' });
        return;
      }

      if (this.departamento_sel) this.input.iddepartamento = this.departamento_sel.id;
      if (this.pais_sel) this.input.idpais = this.pais_sel.id;
      this.input.grados = this.grado_sel.map(item => ({ idgrado: item.id, titulo: item.nombre }));
      this.input.est_civil = this.est_civil_sel.id;
      const obj = window.Object.assign({}, this.input);
      obj.telefono1 = obj.telefono1.replace(/\D/g, '');

      this.loading = true;
      const res = await this.personService.updatePersona(this, obj);
      if (res && res.networkError && res.networkError.result) {
        let msg = '';
        res.networkError.result.errors.forEach(e => msg += `${e.message} `);
        this.$root.$notify.show(msg, { color: 'red' });
      }
      if (res && res.graphQLErrors) {
        let msg = '';
        res.graphQLErrors.forEach(e => {
          e.message.message.forEach(x => { msg += `${x.error} `; });
        });
        this.$root.$notify.show(msg, { color: 'red' });
      }
      if (res && res.data) {
        const r = res.data.updatePersona;
        if (r.ok) this.$root.$notify.show('Guardado', { color: 'green' });
        else {
          let msg = '';
          r.errors.forEach(e => msg += `${e.message} `);
          this.$root.$notify.show(msg, { color: 'red' });
        }
      }
      window.console.log('---', JSON.stringify(res));
      this.loading = false;
    },
  },
  mounted() {
    this.user_id = this.$route.query.id;
    if (this.user_id) this.input.id = parseInt(this.user_id);
    this.getdata();
  },
};
</script>

<style scoped>
.ed-page { min-height: 100vh; background: #f5f7fa; }

.ed-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.ed-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.ed-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.75); margin-top: 2px; }

.ed-body { padding: 20px 24px; }

.ed-info-card {
  border-radius: 10px !important;
  border-color: #c5cae9 !important;
  background: #f0f3ff !important;
}
.ed-info-item { display: flex; flex-direction: column; gap: 1px; }
.ed-info-label { font-size: 0.68rem; text-transform: uppercase; letter-spacing: 0.06em; color: #7986cb; font-weight: 700; }
.ed-info-val   { font-size: 0.88rem; font-weight: 600; color: #1a237e; }

.ed-form-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }
.ed-form-title {
  font-size: 0.8rem !important; font-weight: 700 !important;
  color: #283593; letter-spacing: 0.02em; border-bottom: 1px solid #e8edf7;
}

.ed-tel-input {
  border: 1px solid rgba(0,0,0,0.38) !important;
  border-radius: 4px !important;
  padding: 6px 8px !important;
  width: 100% !important;
  font-size: 0.875rem !important;
  height: 40px;
}
.ed-tel-input:focus-within {
  border-color: #1a237e !important;
  box-shadow: none !important;
}
</style>
